import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

import { computed, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MintButton',
  props: ['candyMachine', 'isMinting', 'onMint'],
  setup(__props) {

const props = __props


const clicked = ref(false);

const getMintButtonContent = computed(() => {
  if (props.candyMachine?.state?.isSoldOut) {
    return 'SOLD OUT';
  } else if (props.isMinting) {
    return 'LOADING...';
  } else if (props.candyMachine?.state?.isPresale) {
    return 'PRESALE MINT';
  }

  return 'MINT';
});

const disabled = computed(
  () =>
    props.candyMachine?.state?.isSoldOut ||
    props.isMinting ||
    !props.candyMachine?.state?.isActive
);

watch([clicked], props.onMint);

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(_component_b_button, {
    size: "lg",
    class: "my-3",
    variant: "primary",
    disabled: _unref(disabled),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (clicked.value = true))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(getMintButtonContent)), 1)
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})